import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

class ProgresBar extends Component {
    render() {
        const { t } = this.props;
        return (
            <ul className="progress-tracker progress-tracker--text progress-tracker--center progress-tracker--spaced anim-path">

                <li className="progress-step" >
                    <a href="#/" btattached="true" >
                        <span className="progress-marker" id={(this.props.isCompleteBrand) ? 'is-complete' : 'is-active'} onClick={() => this.props.selectDotOne(true, true)}>1</span>
                        <span className="progress-text">
                            <div className="progress-title" id={(this.props.isCompleteBrand) ? 'is-complete-text' : 'is-active-text'} onClick={() => this.props.selectDotOne(true, true)}>{t("progress.step1")}</div>
                        </span>
                    </a>
                </li>
                <li className="progress-step ">
                    <a href="#/" btattached="true">
                        <span className="progress-marker" id={(this.props.isCompleteBrand && this.props.isCompleteBulp) ? 'is-complete' : (this.props.isCompleteBrand) ? 'is-active' : ''} onClick={() => this.props.selectDotTwo(true)} >2</span>
                        <span className="progress-text">
                            <div className="progress-title" id={(this.props.isCompleteBrand && this.props.isCompleteBulp) ? 'is-complete-text' : (this.props.isCompleteBrand) ? 'is-active-text' : ''} onClick={() => this.props.selectDotTwo(true)}>{t("progress.step2")}</div>
                        </span>
                    </a>
                </li>
                <li className="progress-step">
                    <a href="#/" btattached="true">
                        <span className="progress-marker" id={(this.props.isCompleteBulp && this.props.isCompleteNote) ? 'is-complete' : (this.props.isCompleteBulp) ? 'is-active' : ''} onClick={() => this.props.selectDotThree(true)}>3</span>
                        <span className="progress-text">
                            <div className="progress-title" id={(this.props.isCompleteBulp && this.props.isCompleteNote) ? 'is-complete-text' : (this.props.isCompleteBulp) ? 'is-active-text' : ''} onClick={() => this.props.selectDotThree(true)}>{t("progress.step3")}</div>
                        </span>
                    </a>
                </li>
                <li className="progress-step">
                    <a href="#/" btattached="true">
                        <span className="progress-marker" id={(this.props.isCompleteNote) ? 'is-active' : ''} onClick={this.props.selectDotFour}>4</span>
                        <span className="progress-text">
                            <div className="progress-title" id={(this.props.isCompleteNote) ? 'is-active-text' : ''} onClick={this.props.selectDotFour}>{t("progress.step4")}</div>
                        </span>
                    </a>
                </li>

            </ul>
        )
    }
}

export default withTranslation()(ProgresBar);